export default __webpack_public_path__ + "8036d653e073f39af97c2583721cb3bc.png";